import { httpClient } from '../http/httpClient'
export interface getAmountResponse {
  amount: number
  adminAmount?: number
  config: {
    withdrawsRemaining: number
    minWithdrawAmount: number
    withdrawFee: number
  }
  extract: false
}

export async function getAmount() {
  const { data } = await httpClient.get<getAmountResponse>(`/withdraw/amount`)

  return data
}
